import axios from 'axios';

// Both production domains (app.mboawallet.com, mboasend.com) are served by the SAME deployment:
// call the API on the domain the user opened, so neither domain depends on the other.
const PROD_HOSTS = ['mboasend.com', 'www.mboasend.com', 'app.mboasend.com', 'app.mboawallet.com'];
const sameOrigin = typeof window !== 'undefined' && PROD_HOSTS.includes(window.location.hostname);
export const BACKEND_URL = sameOrigin ? window.location.origin : process.env.REACT_APP_BACKEND_URL;
export const APP_ORIGIN = typeof window !== 'undefined' ? window.location.origin : 'https://mboasend.com';
export const APP_HOST = typeof window !== 'undefined' ? window.location.host : 'mboasend.com';
const API_BASE = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API_BASE });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('mboa_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      const refreshToken = localStorage.getItem('mboa_refresh');
      if (refreshToken) {
        try {
          const res = await axios.post(`${API_BASE}/auth/refresh`, { refresh_token: refreshToken });
          localStorage.setItem('mboa_token', res.data.token);
          originalRequest.headers.Authorization = `Bearer ${res.data.token}`;
          return api(originalRequest);
        } catch {
          localStorage.removeItem('mboa_token');
          localStorage.removeItem('mboa_refresh');
          localStorage.removeItem('mboa_user');
          if (!['/login', '/register', '/'].includes(window.location.pathname)) {
            window.location.href = '/login';
          }
        }
      } else {
        localStorage.removeItem('mboa_token');
        localStorage.removeItem('mboa_user');
        if (!['/login', '/register', '/'].includes(window.location.pathname)) {
          window.location.href = '/login';
        }
      }
    }
    return Promise.reject(error);
  }
);

export default api;
